import React from "react";

interface SectionHeaderProps {
  title: string;
  description?: string;
  align?: "left" | "center" | "right";
}

const SectionHeader = ({
  title,
  description,
  align = "center",
}: SectionHeaderProps) => {
  const words = title.split(" ");
  const mid = Math.ceil(words.length / 2); // majority goes to white
  const firstHalf = words.slice(0, mid).join(" ");
  const secondHalf = words.slice(mid).join(" ");

  return (
    <section className="">
      <article
        className=" flex flex-col w-full items-center justify-center "
        style={{
          justifyContent:
            align === "left"
              ? "flex-start"
              : align === "right"
                ? "flex-end"
                : "center",
          alignItems:
            align === "left"
              ? "flex-start"
              : align === "right"
                ? "flex-end"
                : "center",
        }}
      >
        <h2
          className="section-title text-center md:text-left"
        >
          <strong className="!font-semibold">
            <span className="text-white">{firstHalf}</span>{" "}
            <span className="text-primary">{secondHalf}</span>
          </strong>
        </h2>
        <p className="section-description !text-light-text text-center md:text-left">{description}</p>
      </article>
    </section>
  );
};

export default SectionHeader;
